import React from 'react';
import { Box, Button } from '@chakra-ui/react';
import { wizardTokens } from '../styles';

interface WizardBottomBarProps {
  label: string;
  loadingText?: string;
  onClick: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  secondary?: React.ReactNode;
}

// Sticky footer holding the primary CTA (board: lime pill, grey when off). Full-bleed width — the
// button itself stays centered and narrow via the inner maxW box below.
const WizardBottomBar: React.FC<WizardBottomBarProps> = ({
  label,
  loadingText,
  onClick,
  isDisabled = false,
  isLoading = false,
  secondary,
}) => (
  <Box
    position="sticky"
    bottom={0}
    mt={4}
    w="100%"
    p="14px 20px"
    pb="calc(env(safe-area-inset-bottom) + 28px)"
    bg="#FFFFFF"
    borderTop="1px solid #ECECEA"
    zIndex={10}
    fontFamily="display"
  >
    <Box maxW={{ base: '560px', lg: '720px' }} mx="auto">
      <Button
        width="100%"
        h={wizardTokens.ctaHeight}
        borderRadius="999px"
        bg="#C6F432"
        color={wizardTokens.ink}
        fontFamily="display"
        fontSize="16px"
        fontWeight={600}
        onClick={onClick}
        isDisabled={isDisabled}
        isLoading={isLoading}
        loadingText={loadingText}
        _hover={{ bg: '#C6F432', _disabled: { bg: '#ECECEA' } }}
        _active={{ bg: '#AED923' }}
        _disabled={{ bg: '#ECECEA', color: '#6E6E72', cursor: 'not-allowed', opacity: 1 }}
      >
        {label}
      </Button>
      {secondary}
    </Box>
  </Box>
);

export default WizardBottomBar;
